import { ITicket } from "../../types/dashboard";
import { getDatesList } from "../../utils/yearsGen";

export const getFirstMonthDay = (date: Date)=>{
    const testDate = new Date(date.valueOf());
    testDate.setUTCDate(1);
    return testDate.getUTCDay();
}

export const getShownDates = (date: Date)=>{
    const firstDate = getFirstMonthDay(date);
    const testDate = new Date(date.valueOf());
    const lastYear = testDate.getUTCFullYear() - 1;
    const lastMonth = testDate.getUTCMonth() - 1;

    const baseDate = new Date(0);
    baseDate.setUTCFullYear(date.getUTCFullYear());
    baseDate.setUTCMonth(date.getUTCMonth());

    const lastMonthDates = lastMonth == -1 ? getDatesList(lastYear, 11) : getDatesList(testDate.getUTCFullYear(), lastMonth);
    const lastMonthBaseDate = new Date(0);
    lastMonthBaseDate.setUTCFullYear(lastMonth == -1 ? lastYear : lastYear+1);
    lastMonthBaseDate.setUTCMonth(lastMonth == -1 ? 11 : lastMonth);

    const nextMonthDates = (testDate.getUTCMonth() + 1 == 12) ? getDatesList(testDate.getUTCFullYear() + 1, 0) : getDatesList(testDate.getUTCFullYear(), testDate.getUTCMonth() + 1);
    const nextMonthBaseDate = new Date(0);
    nextMonthBaseDate.setUTCFullYear((testDate.getUTCMonth() + 1 == 12) ? lastYear+2 : lastYear+1);
    nextMonthBaseDate.setUTCMonth((testDate.getUTCMonth() + 1 == 12) ? 0 : testDate.getUTCMonth() + 1);
    //testDate.setUTCDate(-firstDate);
    //console.log(nextMonthDates, lastMonthDates)
    const lastShownDates = lastMonthDates.slice(lastMonthDates.length - firstDate);
    const currentShownDates = getDatesList(testDate.getUTCFullYear(), testDate.getUTCMonth());
    const currentLength = lastShownDates.length + currentShownDates.length;
    //console.log(currentLength, currentShownDates);
    const lengthToRound = Math.ceil(currentLength / 7) * 7 - currentLength;
    return [...lastShownDates.map(it=>{
        const dt = new Date(lastMonthBaseDate);
        dt.setUTCDate(it);
        return dt;
    }), ...currentShownDates.map(it=>{
        const dt = new Date(baseDate);
        dt.setUTCDate(it);
        return dt;
    }), 
    ...nextMonthDates.slice(0, lengthToRound).map(it=>{
        const dt = new Date(nextMonthBaseDate);
        dt.setUTCDate(it);
        return dt;
    })];
}

export const getDayTickets = (day: number, tickets: ITicket[]) =>{
    return tickets.filter(ticket=>ticket.start.getUTCDate() == day);
}

export const isTicketsIntersects = (a: ITicket, b: ITicket) =>{
    const lengthA = a.end.valueOf() - a.start.valueOf();
    const lengthB = b.end.valueOf() - b.start.valueOf();
    const lengthAB = Math.min(a.start.valueOf(), b.start.valueOf()) - Math.max(a.end.valueOf(), b.end.valueOf());
    return Math.abs(lengthA) + Math.abs(lengthB) > Math.abs(lengthAB);
    //return (a.start < b.end && b.start < b.end) || (a.start > b.start && a.end < b.end) || (b.start > a.start && b.end < a.end);
}

export const getDayTicketWithColumns = (day: number, tickets: ITicket[]) =>{
    const dayTickets = getDayTickets(day, tickets).sort((a, b)=> a.start.valueOf() - b.start.valueOf());
    const ticketsWithColumns: {ticket: ITicket, column: number, columns: number, totalColumns: number}[] = [];
    let columns: ITicket[][] = [];
    dayTickets.forEach(ticket=>{
        const lastInCols = columns.map(it=>it[it.length -1]);
        const intersections = lastInCols.map((it, i)=>{
            return isTicketsIntersects(ticket, it);
        });
        const firstIndex = intersections.findIndex(it=> it==false);
        if (firstIndex == -1){
            columns.push([ticket]);
        } else {
            columns[firstIndex].push(ticket);
        }
    });

    console.log('cols', columns);

    columns.forEach((col, colIndex)=>{
        col.forEach(it=>{
            let freeCount = 0;
            for (let i=0; i<100; i++){
                let nextCol = columns[colIndex + i + 1];
                if (!nextCol){
                    break;
                } else {
                    const isNextFree = nextCol.find(jt=>isTicketsIntersects(it, jt)) == null;
                    if (isNextFree) {
                        freeCount++;
                    } else {
                        break; 
                    }
                }
            }
            ticketsWithColumns.push({
                ticket: it,
                column: colIndex,
                columns: freeCount+1,
                totalColumns: columns.length
            })
        });
    });
    console.log(ticketsWithColumns);
    return ticketsWithColumns.sort((a, b)=> a.ticket.start.valueOf() - b.ticket.start.valueOf());;
    /*ticketsWithColumns.push({
        ticket,
        column: 0,
        totalColumns: 1
    })*/
}

export const getTicketColorByType = (type: string)=>{
    const colorStyles = {
        session: 'calendarGrid_ticket--colorA',
        event: 'calendarGrid_ticket--colorC',
        task: 'calendarGrid_ticket--colorB'
    };
    return colorStyles[type as keyof typeof colorStyles] || 'calendarGrid_ticket--colorA';
}

export const generateTicket = (): ITicket=>{
    const start = new Date();
    start.setUTCDate(start.getUTCDate() + Math.floor(Math.random() * 6));
    start.setUTCHours(Math.floor(Math.random() * 24));
    start.setUTCMinutes(Math.floor(Math.random() * 60));
    const end = new Date(start);
    end.setUTCHours(end.getUTCHours() + Math.floor(Math.random() * 3 + 1));
    end.setUTCMinutes(Math.floor(Math.random() * 60));
    return {
        start: start,
        end: end,
        title: 'qwert',
        type: 'session'
    }
}